module.exports = __webpack_public_path__ + "static/media/Dieb.a5a90ec1.mp3";